import { useState } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { OrganisationCombobox, type OrganisationChoice } from '../../components/OrganisationCombobox'

/** Step one of "Samenvoegen met…" on the organisation page: pick the other organisation. */
export function PickOrganisationDialog({
  excludeId,
  onClose,
  onPicked,
}: {
  excludeId: string
  onClose: () => void
  onPicked: (organisationId: string) => void
}) {
  const [choice, setChoice] = useState<OrganisationChoice | null>(null)
  return (
    <Dialog open onOpenChange={(next) => (next ? undefined : onClose())}>
      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>Samenvoegen met…</DialogTitle>
          <DialogDescription>Kies de organisatie die je met deze wilt samenvoegen.</DialogDescription>
        </DialogHeader>
        <OrganisationCombobox
          label="Andere organisatie"
          value={choice}
          excludeId={excludeId}
          allowNew={false}
          autoFocus
          onChange={(picked) => {
            setChoice(picked)
            if (picked?.kind === 'existing') onPicked(picked.id)
          }}
        />
      </DialogContent>
    </Dialog>
  )
}
